// extracted by mini-css-extract-plugin
export default {"item":"burger-item_item__tlDcn","price":"burger-item_price__dUyjv","card":"burger-item_card__k+3m5"};